/* eslint-disable react/jsx-pascal-case */
import PropTypes from "prop-types";

import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import DeckSelection from "./DeckSelection";
import DeckStructure from "./DeckStructure";
import DeckMaterial from "./DeckMaterial";
import { fixedState, useDeckState } from "./DecksState";
import { isStepSkipped, handleNext, handleBack, handleSkip, handleFinish } from "./StepperHelper";
// import DeckDirection from "./DeckDirection";
// import DeckHeight from "./DeckHeight";
import DeckAttachment from "./DeckAttachment";
import BSL_Button from "../components/BSL_Button";

const DecksPage = ({ deckState, updateDeckState, setDeckPageOpen }) => {
    const [activeStep, setActiveStep] = useState(0);
    const [skipped, setSkipped] = useState(new Set());

    let steps = [
        {
            label: "Select Your Deck",
            component: <DeckSelection deckState={deckState} updateDeckState={updateDeckState} />,
        },
        {
            label: "Deck Dimensions",
            component: <DeckStructure deckState={deckState} updateDeckState={updateDeckState} />,
        },
        {
            label: "Attachments",
            component: <DeckAttachment deckState={deckState} updateDeckState={updateDeckState} />,
        },
        // {
        //   label: "Set Deck Height",
        //   component: (
        //     <DeckHeight deckState={deckState} updateDeckState={updateDeckState} />
        //   ),
        // },
        {
            label: "Joist Spacing & Material",
            component: <DeckMaterial deckState={deckState} updateDeckState={updateDeckState} />,
        },
        // {
        //   label: "Deck Direction",
        //   component: (
        //     <DeckDirection
        //       deckState={deckState}
        //       updateDeckState={updateDeckState}
        //     />
        //   ),
        // },
    ];

    // Set new state
    React.useEffect(() => {
        if (!deckState.finished) {
            const newState = {
                deckStructure: {
                    deckDirection: "Horizontal",
                    deckAttachment: "Masonry",
                    widthA: 1500,
                    widthB: 3600,
                    lengthA: 2500,
                    lengthB: 2000,
                    deckShape: "Rectangle / Square",
                    deckRotation: 0,
                    deckHeight: 500,
                    deckFreestanding: false,
                },
                deckMaterial: fixedState.deckMaterial[0],
                deckAttachments: { rect1: {}, rect2: {} },
                designer: {
                    showPopup: false,
                    accepted: false,
                },
                deckFooting: "",
                finished: false,
            };

            updateDeckState(newState);
        }
    }, []);

    console.log(deckState);

    const handleCurrentPage = () => steps[activeStep].component;

    return (
        <Box id="deckbuilder" sx={{ boxShadow: 24, p: 4 }}>
            <Stepper activeStep={activeStep}>
                {steps.map((step, index) => {
                    const stepProps = {};
                    const labelProps = {};
                    const uniqueKey = `${step.label}_${index}`;
                    if (isStepSkipped(index, skipped)) {
                        stepProps.completed = false;
                    }
                    return (
                        <Step key={uniqueKey} {...stepProps}>
                            <StepLabel {...labelProps}>{step.label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            {activeStep === steps.length ? (
                <React.Fragment>
                    <Typography sx={{ mt: 2, mb: 1 }}>All steps completed - you&apos;re finished</Typography>
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button onClick={() => handleFinish(deckState)}>Finish</Button>
                    </Box>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    {handleCurrentPage()} {/* Invoke the function to render the page */}
                    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                        <BSL_Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={() => handleBack(activeStep, setActiveStep)}
                            sx={{ mr: 1 }}
                        >
                            Back
                        </BSL_Button>
                        <Box sx={{ flex: "1 1 auto" }} />
                        <BSL_Button
                            onClick={() =>
                                handleNext(
                                    activeStep,
                                    skipped,
                                    setActiveStep,
                                    setSkipped,
                                    activeStep === steps.length - 1,
                                    updateDeckState,
                                    deckState,
                                    setDeckPageOpen
                                )
                            }
                        >
                            {activeStep === steps.length - 1 ? "Create Job" : "Next"}
                        </BSL_Button>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    );
};

DecksPage.propTypes = {
    deckState: PropTypes.shape({
        deckStructure: PropTypes.shape({
            deckDirection: PropTypes.oneOf(fixedState.deckStructure.deckDirection),
            deckAttachment: PropTypes.oneOf(fixedState.deckStructure.deckAttachment),
            deckShape: PropTypes.oneOf(fixedState.deckStructure.deckShape),
            widthA: PropTypes.number,
            widthB: PropTypes.number,
            lengthA: PropTypes.number,
            lengthB: PropTypes.number,
            deckRotation: PropTypes.number,
            deckHeight: PropTypes.number,
            deckFreestanding: PropTypes.bool,
        }),
        deckMaterial: PropTypes.oneOf(fixedState.deckMaterial),
        deckAttachments: PropTypes.number,
        deckFooting: PropTypes.number,
    }),
};

export default DecksPage;
